import {Directive, forwardRef} from '@angular/core';
import {UntypedFormControl, NG_VALIDATORS, Validator} from '@angular/forms';

function validatePostalCode() {
  return (c: UntypedFormControl) => {
    const postalCodeRegex = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?(\d[ABCEGHJKLMNPRSTVWXYZ]\d)?$/i);

    if (c.value === undefined || c.value === null || c.value?.length === 0){
      return null;
    }
    
    return postalCodeRegex.test(c.value) ? null : {
      postalCode: {
        valid: false
      }
    };
  };
}

@Directive({
  selector: '[appPostalCodeValidator]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => PostalCodeValidatorDirective), multi: true}
  ]

})
export class PostalCodeValidatorDirective implements Validator {

  validator: Function;

  constructor() {
    this.validator = validatePostalCode();
  }

  validate(c: UntypedFormControl) {
    return this.validator(c);
  }
}

